import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/images/ar-images/nav-icon.png'


const _hoisted_1 = {
  key: 1,
  class: "title"
}
const _hoisted_2 = { class: "top-con" }
const _hoisted_3 = { class: "img-box" }
const _hoisted_4 = ["src", "onMousemove"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "desc" }
const _hoisted_7 = { class: "foooter" }
const _hoisted_8 = {
  key: 0,
  class: "sub-style"
}
const _hoisted_9 = {
  key: 1,
  class: "bottom-con"
}
const _hoisted_10 = { class: "l-con" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "remark" }
const _hoisted_14 = { class: "r-con" }
const _hoisted_15 = ["src"]

import { ref, onMounted, watch } from 'vue'
import SubTitle from '@/components/SubTitle.vue';
import { asynchronousRetrieval } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExampleIntroduction',
  props: {
  exampleData: {
    default: null,
    type: Object
  },
  modeClass: {
    default: '',
    type: String
  },
  titleClass: {
    default: '',
    type: String
  },
},
  setup(__props) {

const props = __props

const activeItemIndex = ref(0)
const loadUrl: any = ref({})
const showIndex = ref(-1);
const showKeyMap: any = {
  kjsj: ['qyzt', 'scdkj'],
  arWechat: ['mlc', 'qtxct', 'bskl', 'jryx'],
  xnfz: ['sxcz', 'xnzp', 'cjsjc', 'hxkp'],
  xnbwg: ['bwgjs', 'bwgsd', 'bwgbj', 'bwgzj'],
  ardh: ['mlc', 'ckzc', 'jqdh', 'zhyq'],
  yyzzt: ['ddzs', 'yyzzt', 'jswysg', 'sxcz']
};

const loadGif = async (gifKey: string) => {
  const currentTimeStamp = new Date().getTime();
  if (!loadUrl.value[showKeyMap[gifKey][showIndex.value]] || (currentTimeStamp - loadUrl.value[showKeyMap[gifKey][showIndex.value]].timeStamp) > 10000) {
    const lastLoadObj = await asynchronousRetrieval(`webimg/gif/${showKeyMap[gifKey][showIndex.value]}.gif`);
    loadUrl.value[showKeyMap[gifKey][showIndex.value]] = {
      url: lastLoadObj,
      timeStamp: currentTimeStamp
    };
  }
}

onMounted(() => {
  loadGif(props.exampleData.keyName)
})

watch(() => showIndex.value, (newState) => {
  if (newState != -1) {
    loadGif(props.exampleData.keyName)
  }
})




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "sljs-box",
    style: _normalizeStyle({paddingTop: __props.titleClass ? '90rem' : 'auto'})
  }, [
    (!__props.titleClass)
      ? (_openBlock(), _createBlock(SubTitle, {
          key: 0,
          "title-text": "实例介绍",
          "mode-class": __props.modeClass
        }, null, 8, ["mode-class"]))
      : _createCommentVNode("", true),
    (__props.titleClass)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "实例介绍"))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "sljs",
      style: _normalizeStyle({ paddingBottom: __props.exampleData.itemList ? '120rem' : 0 })
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.exampleData.example, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: item.url,
                onMousemove: ($event: any) => (showIndex.value = index)
              }, null, 40, _hoisted_4),
              (showIndex.value == index)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: loadUrl.value[showKeyMap[__props.exampleData.keyName][showIndex.value]]?.url,
                    onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (showIndex.value = -1))
                  }, null, 40, _hoisted_5))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_7, [
              _cache[1] || (_cache[1] = _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(item.address), 1)
            ])
          ]))
        }), 128))
      ]),
      (__props.exampleData.itemList && !__props.modeClass)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(SubTitle, { "title-text": "合作方式" })
          ]))
        : _createCommentVNode("", true),
      (__props.exampleData.itemList && !__props.modeClass)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.exampleData.itemList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(item.className + ' ' + (index == activeItemIndex.value ? 'active' : '')),
                  key: index,
                  onClick: ($event: any) => (activeItemIndex.value = index)
                }, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(item.remark), 1)
                ], 10, _hoisted_11))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("img", {
                src: __props.exampleData.itemList[activeItemIndex.value].url,
                alt: ""
              }, null, 8, _hoisted_15)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 4)
  ], 4))
}
}

})